import { useQuery } from '@tanstack/react-query';
import { axios } from '@/src/lib/axios/axios';
import { PREFIX_URL } from '@/src/api/config';
import { generateRoutePath } from '@/src/routes';

type LineAccount = {
  account: { id: string; name: string; type: string };
  description: string;
  qty: string;
  unitPrice: string;
  totalAmount: string;
  taxCode: {
    id: string;
    name: string;
    rates: { name: string; id: string; description: string; rate: number }[];
  };
  item: null | Record<string, unknown>;
  class: { id: string; name: string; type: string };
};
interface LineSuggestionsResponse {
  lineAccounts?: LineAccount[];
}

interface PayeeData {
  payeeId: string;
  payeeType: string;
}

const fetchLineSuggestions = async (
  documentId: number,
  payeeData: PayeeData
): Promise<LineAccount[]> => {
  const url = `${PREFIX_URL}/quickbooks/${documentId}/getLinesSuggestions`;
  const response: LineSuggestionsResponse = await axios.post(generateRoutePath(url), payeeData);
  return response.lineAccounts ?? [];
};

const useGetLinesSuggestions = (documentId: number, payeeData: PayeeData) => {
  return useQuery<LineAccount[]>(
    ['lineSuggestions', documentId, payeeData?.payeeId, payeeData?.payeeType],
    () => fetchLineSuggestions(documentId, payeeData),
    {
      enabled: !!documentId && !!payeeData?.payeeId && !!payeeData?.payeeType,
      onError: (error) => {
        console.error('Error fetching line suggestions:', error);
      },
    }
  );
};

export default useGetLinesSuggestions;
